var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main__container"},[_c('oz-buying-power-banner'),_c('oz-buying-power-calculator',{staticClass:"buying-power__component buying-power__component-calculator"}),_c('oz-buying-power-result',{staticClass:"buying-power__component buying-power__component-result"}),_c('oz-buying-power-credit-banner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }